exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".home-logo-div{justify-content:center;margin:60px auto;text-align:center}.home-logo{height:60vmin;width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/homeLogo/HomeLogo.scss
// module id = 325
// module chunks = 0